export const normalizeUserRole = (role?: string | null): string => (role || '').trim().toLowerCase()

export const isPartnerReadOnlyUserRole = (role?: string | null): boolean => {
  const normalized = normalizeUserRole(role)
  return normalized === 'partner.user' || normalized === 'partner_user'
}

export const canManagePartnerPortalRole = (role?: string | null): boolean => {
  const normalized = normalizeUserRole(role)
  if (!normalized) return false
  if (isPartnerReadOnlyUserRole(normalized)) return false
  return normalized.includes('admin')
}
